import { CaretUpOutlined } from '@ant-design/icons';
import { IAptGroupByTimeAppointmentData, IAptGroupByTimeItemData } from 'features/user/services/types/apt';
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import AppointmentCard from './AppointmentCard';

type Props = {
  data: IAptGroupByTimeItemData;
  onAppointmentClick: (apt: IAptGroupByTimeAppointmentData) => void;
};

const AptGroupByTimeItem = ({ data, onAppointmentClick }: Props) => {
  const [expanded, setExpanded] = useState(true);

  const countLabel = useMemo(() => {
    const n = data.totalAppointments;
    return `${n} APPT${n === 1 ? '' : 'S'}`;
  }, [data.totalAppointments]);

  return (
    <Root>
      <HeaderBar onClick={() => setExpanded((v) => !v)} type='button'>
        <TimeBadge>
          <TimeBadgeText>{data.time}</TimeBadgeText>
        </TimeBadge>
        <HeaderRight>
          <CountBadge>{countLabel}</CountBadge>
          <ChevronWrap $expanded={expanded}>
            <CaretUpOutlined />
          </ChevronWrap>
        </HeaderRight>
      </HeaderBar>

      {expanded && (
        <CardsSection>
          {data.appointments.map((apt) => (
            <AppointmentCard key={apt.appointmentId} apt={apt} onClick={() => onAppointmentClick(apt)} />
          ))}
        </CardsSection>
      )}
    </Root>
  );
};

export default AptGroupByTimeItem;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
`;

const HeaderBar = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0;
  padding: 16px 16px 4px;
  border: none;
  background: #f6f7fc;
  cursor: pointer;
  text-align: left;
  font: inherit;
`;

const TimeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  border-radius: 4px;
  background: #c84b31;
  max-width: 100%;
`;

const TimeBadgeText = styled.span`
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: normal;
  color: #ffffff;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 100px;
  background: #2563eb;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  white-space: nowrap;
`;

const ChevronWrap = styled.span<{ $expanded: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #1d2129;
  transform: rotate(${(p) => (p.$expanded ? '0deg' : '180deg')});
  transition: transform 0.2s ease;
`;

const CardsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  // padding: 0 16px 8px;
  padding: 8px;
  background: #fff;
`;
